import { define } from 'wicked-elements'
import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.css";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.autoplay.css";

define('[data-component="carousel"]', {
  connected () {
    this.carousel = new Carousel(this.element, {
      loop: true,
      Dots: false,
      Navigation: false,
      Autoplay: {
        timeout: 5000,
        showProgress: false,
        pauseOnHover: false,
      },
      on: {
        click: () => {
          this.carousel.slideNext()
        }
      }
    }, { Autoplay })

    // Intersection Observer to control autoplay
    this._observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (this.carousel && this.carousel.plugins && this.carousel.plugins.Autoplay) {
          if (entry.isIntersecting) {
            this.carousel.plugins.Autoplay.start();
          } else {
            this.carousel.plugins.Autoplay.stop();
          }
        }
      });
    }, { threshold: 0.1 });
    this._observer.observe(this.element);
  },
  disconnected () {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }
  }
})